<div class="card-content" id="abaPagamento">
  <div class="card-body">
    <div class="card-content">
      <h4
        *ngIf="dadosBeneficiario && !dadosBeneficiario[0].dadosBeneficiario?.isGeia"
        class="form-section text-center col-12 text-bold-600 preto-geia mb-2 mt-1">
        Olá, Colaborador.
      </h4>
      <h4
        *ngIf="dadosBeneficiario && dadosBeneficiario[0].dadosBeneficiario?.isGeia"
        class="form-section text-center col-12 text-bold-600 preto-geia mb-2 mt-1">
        Olá, Corretor.
      </h4>
      <div class="card-body card-form">
        <h4 class="form-section text-center col-12 text-bold-600 preto-geia mb-2 mt-1">
          PAGAMENTO DA TAXA DE ADESÃO - {{ somenteLeituraStep | json }}
        </h4>
        <div class="row">
          <div class="col-md-3 col-sm-12 mb-1">
            <div class="border-bottom">
              <strong>Contrato:</strong>
              {{ formTitular.get('contrato')?.value || '000000' }}
            </div>
          </div>
          <div class="col-md-5 col-sm-12 mb-1">
            <div class="border-bottom">
              <strong>Nome:</strong>
              {{ formTitular.get('name')?.value || 'Nome Completo Contratante' }}
            </div>
          </div>
          <div class="col-md-4 col-sm-12 mb-1">
            <div class="border-bottom">
              <strong>Telefone:</strong>
              {{ formTitular.get('telephone')?.value | mask: '(00) 00000-0000' }}
            </div>
          </div>
        </div>

        <!-- Segunda linha - informações complementares -->
        <div class="row mb-1">
          <div class="col-md-4 col-sm-12 mb-1">
            <div class="border-bottom">
              <strong>Email:</strong>
              {{ formTitular.get('email')?.value || 'email@gmail.com' }}
            </div>
          </div>
          <div class="col-md-8 col-sm-12 mb-1">
            <div class="border-bottom">
              <strong>Endereço:</strong>
              {{
                formTitular.get('endereco')?.value + ', ' + formTitular.get('numero')?.value ||
                  'Rua Endereço Completo, Número'
              }}
              <span></span>
              <strong>Cep:</strong>

              {{ formTitular.get('cep')?.value | mask: '00000-000' }}
            </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <div class="border-bottom">
              <strong>Cidade:</strong>
              {{ formTitular.get('cidade')?.value }}
            </div>
          </div>
        </div>
      </div>

      <!-- Histórico de contratação -->
      <div class="table-responsive card-form mt-4 w-100 form-section col-12 text-bold-600 preto-geia">
        <h4 style="margin-top: 16px !important; padding: 3px" class="form-section">
          <i class="ft-check"></i>
          Histórico de Contratação
        </h4>

        <hr />
        <table class="table table-bordered">
          <thead class="bg-table-geia white">
            <tr>
              <th class="text-center">Produto</th>
              <th class="text-center">Nome</th>
              <th class="text-center">Titularidade</th>
              <th class="text-center">Data de Nascimento</th>
              <th class="text-center">Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaHistorico; let i = index">
              <ng-container *ngIf="i === 0 || item.produto !== listaHistorico[i - 1].produto">
                <td [attr.rowspan]="getRowSpan(item.produto)">
                  {{ item.produto }}
                </td>
              </ng-container>
              <td class="text-center">{{ item.nome }}</td>
              <td class="text-center">{{ item.titularidade }}</td>
              <td class="text-center">
                {{ item.dataNascimento | date: 'dd/MM/yyyy' }}
              </td>
              <td class="text-center">{{ item.valor | currency: 'BRL' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Forma de pagamento -->
      <div
        *ngIf="dadosBeneficiario && !dadosBeneficiario[0].dadosBeneficiario?.isGeia"
        class="table-responsive mt-4 w-100 form-section col-12 text-bold-600 preto-geia card-form">
        <h4 style="margin-top: 16px !important; padding: 3px" class="form-section">
          <i class="ft-check"></i>
          Forma de Pagamento
        </h4>
        <hr />
        <table class="table table-bordered">
          <thead class="bg-table-geia white">
            <tr>
              <th class="text-center">Forma de Pagamento</th>
              <th class="text-center">Data de Emissão</th>
              <th class="text-center">Valor Previsto</th>
              <th class="text-center">Valor Recebido</th>
              <th class="text-center">Comprovante Bancário em Nome de</th>
              <th class="text-center">Data do Crédito</th>
              <!-- <th class="text-center">Comprovante</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPagamentos">
              <td class="text-center">
                {{ getDescricaoFormaPagamento(item.paymentMethod) }}
              </td>
              <td class="text-center">
                {{ item.issueDate | date: 'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="text-center">{{ item.value | currency: 'BRL' }}</td>
              <td class="text-center">
                <div class="input-group">
                  <input
                    type="text"
                    [(ngModel)]="item.valueReceived"
                    class="form-control round"
                    mask="separator.2"
                    thousandSeparator="."
                    decimalMarker=","
                    prefix="R$ " />
                </div>
              </td>
              <td class="text-center">
                <div class="input-group">
                  <input type="text" [(ngModel)]="item.payersName" class="form-control round" />
                </div>
              </td>
              <td class="text-center">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control round"
                    placeholder="DD/MM/AAAA"
                    [(ngModel)]="item.creditsDate"
                    bsDatepicker
                    maxlength="10"
                    [bsConfig]="bsConfig" />
                </div>
              </td>
              <!-- <td class="text-center">
                <div role="group" class="btn-group d-flex justify-content-center align-items-center">
                  <button
                    *ngIf="item.filePath; else reciboNaoAnexado"
                    ngbTooltip="Visualizar Comprovante"
                    class="btn btn-round cursor-pointer box-shadow-4 btn-info"
                    style="border-radius: 50%"
                    (click)="abirModalVisualizar()">
                    <i class="fa fa-eye fa-lg"></i>
                  </button>
                  <ng-template #reciboNaoAnexado>
                    <p>Nenhum recibo anexado pelo beneficiário.</p>
                  </ng-template>
                </div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- CORRETOR -->
      <div
        *ngIf="dadosBeneficiario && dadosBeneficiario[0].dadosBeneficiario?.isGeia"
        class="table-responsive mt-4 w-100 form-section col-12 text-bold-600 preto-geia card-form">
        <h4 style="margin-top: 16px !important; padding: 3px" class="form-section">
          <i class="ft-check"></i>
          Forma de Pagamento
        </h4>
        <hr />
        <table class="table table-bordered">
          <thead class="bg-table-geia white">
            <tr>
              <th class="text-center">Data de Emissão</th>
              <th class="text-center">Valor Previsto</th>
              <th class="text-center">Valor Recebido</th>
              <th class="text-center">Data do Crédito</th>
              <th class="text-center">Comprovante</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaPagamentos">
              <td class="text-center">
                {{ item.issueDate | date: 'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="text-center">{{ item.value | currency: 'BRL' }}</td>
              <td class="text-center">
                <div class="input-group">
                  <input
                    type="text"
                    [(ngModel)]="item.valueReceived"
                    class="form-control round"
                    mask="separator.2"
                    thousandSeparator="."
                    decimalMarker=","
                    prefix="R$ " />
                </div>
              </td>
              <td class="text-center">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control round"
                    placeholder="DD/MM/AAAA"
                    [(ngModel)]="item.creditsDate"
                    bsDatepicker
                    maxlength="10"
                    [bsConfig]="bsConfig" />
                </div>
              </td>
              <td class="text-center">
                <div role="group" class="btn-group d-flex justify-content-center align-items-center">
                  <!-- <button
                    ngbTooltip="Baixar Comprovante"
                    class="btn btn-round cursor-pointer box-shadow-4 btn-warning"
                    (click)="visulizarComprovante(templateModalComprovanteBancario, item)">
                    <i class="fa fa-download fa-lg"></i>
                  </button> -->
                  <button
                    *ngIf="item.filePath; else reciboNaoAnexado"
                    ngbTooltip="Visualizar Comprovante"
                    class="btn btn-round cursor-pointer box-shadow-4 btn-info"
                    style="border-radius: 50%"
                    (click)="abirModalVisualizar()">
                    <i class="fa fa-eye fa-lg"></i>
                  </button>
                  <ng-template #reciboNaoAnexado>
                    <p>Nenhum recibo anexado pelo beneficiário.</p>
                  </ng-template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- CORRETOR END -->
      <!-- Observação -->
      <div class="row mt-3">
        <div class="col-12">
          <div class="form-group">
            <label class="form-section font-weight-bold">Observação</label>
            <div class="rounded">
              <textarea
                [(ngModel)]="observation"
                (input)="contarCaracteres($event); updateCampo()"
                maxlength="2500"
                rows="10"
                class="form-control border-radius box-shadow-4"></textarea>

              <span class="contador-caracteres">{{ caracteresDigitados }}/2500</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Botões -->
    <div class="d-flex justify-content-end mt-3 mb-4">
      <div>
        <ng-container *ngIf="this.stepAtual == propostaEnum.ANALISE_PAGAMENTO && podeCadastrarEditar">
          <ng-container *ngIf="dadosBeneficiario && dadosBeneficiario[0].dadosBeneficiario?.isGeia">
            <app-geia-button
              type="warning"
              label="Notificar Pendência(s)"
              icon="fa fa-bell"
              (onClick)="abrirModalNotificar(templateModalNotificacao)"
              extraClass="round mb-1 mr-1 border-radius box-shadow-4 "></app-geia-button>
          </ng-container>
          <app-declinio-proposta
            [stepAtual]="stepAtual"
            (propostaDeclinada)="receberDeclinio($event)"></app-declinio-proposta>
          <!-- <app-geia-button
            type="info"
            label="Salvar"
            icon="fa fa-save"
            (onClick)="salvarDados()"
            extraClass="round mb-1 mr-1 border-radius box-shadow-4">
          </app-geia-button> -->

          <app-geia-button
            type="success"
            label="Confirmar Pagamento"
            icon="fa fa-check"
            (onClick)="NovoAbrirModalConfirmar(templateModalConfirmarPagamento, 'PAGAMENTO')"
            extraClass="round mb-1 mr-1 border-radius box-shadow-4"></app-geia-button>
        </ng-container>
      </div>
    </div>

    <!-- MODAL CONFIRMAR -->
    <ng-template #templateModalConfirmarPagamento>
      <app-confirm-modal
        [title]="tituloAcaoModal"
        [message]="mensagemConfirmacao"
        (confirm)="confirme('PAGAMENTO')"
        (cancel)="decline('PAGAMENTO')"></app-confirm-modal>
      <br />
    </ng-template>

    <ng-template #templateModalNotificacao>
      <app-modal-simples [title]="'Pendência(s)'" (cancel)="decline()"></app-modal-simples>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-section font-weight-bold">Notificar Pendência(s)</label>
              <div class="rounded">
                <textarea
                  [(ngModel)]="pendencia"
                  (input)="contarCaracteres($event); updateCampo()"
                  maxlength="2500"
                  rows="10"
                  class="form-control border-radius box-shadow-4"></textarea>

                <span class="contador-caracteres">{{ caracteresDigitados }}/2500</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <app-geia-button
            type="info"
            label="Fechar"
            icon="fa fa-times"
            (onClick)="decline()"
            extraClass="round mr-1 border-radius box-shadow-5"></app-geia-button>
          <app-geia-button
            type="warning"
            label="Notificar"
            icon="fa fa-bell"
            (onClick)="NovoAbrirModalConfirmar(templateModalConfirmarNotificar, 'NOTIFICAR')"
            extraClass="round mr-1 border-radius box-shadow-5"></app-geia-button>
        </div>
      </div>
    </ng-template>

    <ng-template #templateModalConfirmarNotificar>
      <app-confirm-modal
        [title]="tituloAcaoModal"
        [message]="mensagemConfirmacao"
        (confirm)="confirme('NOTIFICAR')"
        (cancel)="decline('NOTIFICAR')"></app-confirm-modal>
      <br />
    </ng-template>

    <ng-template #templateModalComprovanteBancario>
      <app-modal-simples [title]="'Comprovante'" (cancel)="decline()"></app-modal-simples>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="form-section font-weight-bold">
                <ng-container *ngIf="hePDF">
                  <pdf-viewer
                    [src]="visualizarArquivoUrl"
                    [rotation]="0"
                    [original-size]="false"
                    [fit-to-page]="false"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="width: 90%; height: 300vh"></pdf-viewer>
                </ng-container>
                <ng-container *ngIf="!hePDF">
                  <img
                    [src]="'https://geia.com.br/assets/app-assets/images/ilustracao/iris-geia-polo.png'"
                    alt="documento banco"
                    width="500"
                    height="500" />
                </ng-container>
              </label>
              <div class="rounded"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <app-geia-button
            type="info"
            label="Fechar"
            icon="fa fa-times"
            (onClick)="decline()"
            extraClass="round mr-1 border-radius box-shadow-5"></app-geia-button>
        </div>
      </div>
    </ng-template>

    <ng-template #modalVisualizarComprovanteBancario>
      <div class="modal-content" style="border: none">
        <div class="modal-header bg-info">
          <h4 class="modal-title" style="font-weight: bold !important; color: #fff">Comprovante de Pagamento</h4>
          <button type="button" class="close" aria-label="Close" (click)="fecharModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngFor="let documento of listaPagamentos" class="mb-4 text-center">
            <img
              *ngIf="isImage(documento.filePath)"
              [src]="documento.filePath"
              alt="Comprovante de Pagamento"
              (load)="onImageLoad()"
              (error)="onImageError()"
              style="max-width: 600px; border: 1px solid #ccc; border-radius: 8px; display: block; margin: 0 auto" />
            <pdf-viewer
              *ngIf="isPdf(documento.filePath)"
              [src]="documento.filePath"
              [render-text]="true"
              (after-load-complete)="onPdfLoadComplete()"
              (error)="onPdfError()"
              style="display: block; width: 100%; height: 800px"></pdf-viewer>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-end m-1" style="border-top: 1px solid #eceeef">
        <div class="modal-footer" style="border-top: none">
          <app-geia-button
            type="geia-blue"
            label="Fechar"
            icon="fa fa-check "
            extraClass="round"
            (onClick)="fecharModal()"></app-geia-button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
